"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lottieReact = _interopRequireDefault(require("lottie-react"));
var _loader = _interopRequireDefault(require("./assets/loader.json"));
require("./Loader.scss");
var _Flex = _interopRequireDefault(require("./Flex"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Loader = function Loader() {
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    customClass: "Loader"
  }, /*#__PURE__*/_react["default"].createElement(_lottieReact["default"], {
    animationData: _loader["default"],
    loop: true,
    autoplay: true
  }));
};
var _default = exports["default"] = Loader;